import axios from 'axios'

const baseurl = `${import.meta.env.VITE_APP_PROTOCOL}://${import.meta.env.VITE_API_HOST}:${import.meta.env.VITE_API_PORT}/${import.meta.env.VITE_API_SUBPATH}`
const url = 'login'

export const loginAPI = async (account: string, password: string) => {
const response = await axios.post(`${baseurl}${url}`, {
      account: account,
      password: password
    });
  if (response.data.message === "Success") {
    console.log("loginAPI 응답:", response.data)
    return response.data.data
  } else {
    console.log("loginAPI 실패")
    return false
  }
}